import supabase from '../supabase/supabase';

const uniqueIds = (values = []) => [...new Set(values.map((value) => String(value || '').trim()).filter(Boolean))];

export const listingViewKey = (listingId) => String(listingId || '');
export const menuEngagementKey = (offerId, itemIndex) => `${offerId}:${Number(itemIndex)}`;

export const engagementService = {
  async recordListingView(listingId) {
    const { data, error } = await supabase.functions.invoke('record-listing-view', {
      body: { listing_id: listingId },
    });
    if (error) throw error;
    if (!data?.success) throw new Error(data?.error || 'Der Aufruf konnte nicht gezählt werden.');
    return {
      counted: Boolean(data.counted),
      viewCount: Number(data.view_count || 0),
    };
  },

  async getListingViewCounts(listingIds = []) {
    const ids = uniqueIds(listingIds);
    if (!ids.length) return {};

    const { data, error } = await supabase.rpc('listing_view_counts', {
      p_listing_ids: ids,
    });
    if (error) throw error;

    return (data || []).reduce((result, row) => {
      result[listingViewKey(row.listing_id)] = Number(row.view_count || 0);
      return result;
    }, {});
  },

  async getMenuItemEngagement(offerIds = []) {
    const ids = uniqueIds(offerIds);
    if (!ids.length) return {};

    const { data, error } = await supabase.rpc('commercial_menu_item_engagement', {
      p_offer_ids: ids,
    });
    if (error) throw error;

    return (data || []).reduce((result, row) => {
      result[menuEngagementKey(row.offer_id, row.item_index)] = {
        offerId: row.offer_id,
        itemIndex: Number(row.item_index),
        dishKey: row.dish_key,
        likeCount: Number(row.like_count || 0),
        likedByMe: Boolean(row.liked_by_me),
      };
      return result;
    }, {});
  },

  async toggleMenuItemLike(offerId, itemIndex) {
    const { data, error } = await supabase.rpc('toggle_commercial_menu_item_like', {
      p_offer_id: offerId,
      p_item_index: Number(itemIndex),
    });
    if (error) throw error;

    const row = Array.isArray(data) ? data[0] : data;
    return {
      offerId: row.offer_id,
      itemIndex: Number(row.item_index),
      dishKey: row.dish_key,
      likeCount: Number(row.like_count || 0),
      likedByMe: Boolean(row.liked_by_me),
    };
  },
};
